export const SUB_OPERATOR_COLUMN_WIDTH = '156px'
